var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  top: 0;\n  left: 0;\n  visibility: hidden;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.5);\n\n  &.modal-open {\n    visibility: visible;\n  }\n"], ["\n  top: 0;\n  left: 0;\n  visibility: hidden;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.5);\n\n  &.modal-open {\n    visibility: visible;\n  }\n"])));
var Outer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  opacity: 0;\n  margin-top: 5%;\n  max-height: 80%;\n  transform: translateY(10em) scale(0.8);\n  transition: all 250ms ease-in-out;\n\n  &.modal-show {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n    transition: all 250ms ease-in-out;\n  }\n\n  & > div > .card {\n    box-shadow: ", ";\n    > .card-body {\n      padding: 2em;\n    }\n  }\n"], ["\n  opacity: 0;\n  margin-top: 5%;\n  max-height: 80%;\n  transform: translateY(10em) scale(0.8);\n  transition: all 250ms ease-in-out;\n\n  &.modal-show {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n    transition: all 250ms ease-in-out;\n  }\n\n  & > div > .card {\n    box-shadow: ", ";\n    > .card-body {\n      padding: 2em;\n    }\n  }\n"])), function (p) {
  return p.theme.boxShadowLarge;
});
var Inner = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var sizes = {
  standard: 'col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3',
  fullWidth: 'col-12'
};

var InnerModal = function InnerModal(_a) {
  var children = _a.children,
      fullWidth = _a.fullWidth,
      isOpen = _a.isOpen,
      modalRef = _a.modalRef;
  return React.createElement(Wrapper, {
    ref: modalRef,
    className: "container-fluid modal-wrapper" + (isOpen ? ' modal-open' : '')
  }, React.createElement(Outer, {
    className: "container modal" + (isOpen ? ' modal-show' : '')
  }, React.createElement("div", {
    className: "row"
  }, React.createElement(Inner, {
    className: fullWidth ? sizes.fullWidth : sizes.standard
  }, children))));
}; // TODO: Manage keyboard and mouse focus for accessibility


var Modal = function Modal(props) {
  var element = document.getElementById('fiducius-root');

  if (element) {
    return ReactDOM.createPortal(React.createElement(InnerModal, props), element);
  } else {
    return null;
  }
};

export default Modal;
var templateObject_1, templateObject_2, templateObject_3;